module.exports = __webpack_public_path__ + "img/pop_kefu.9d51323c.png";